// extracted by mini-css-extract-plugin
module.exports = {"container":"domain-cname_container__8vNPC","content":"domain-cname_content__QiaI5","trouble":"domain-cname_trouble__2oxh1","troubleText":"domain-cname_troubleText__3k-7H"};